import { render, staticRenderFns } from "./CmgTermsAndConditionsModal.vue?vue&type=template&id=f5e9a4ec&scoped=true&lang=pug"
import script from "./cmg-terms-and-conditions-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-terms-and-conditions-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgTermsAndConditionsModal.vue?vue&type=style&index=0&id=f5e9a4ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e9a4ec",
  null
  
)

export default component.exports